import { ByteChannel3cxdguezl3lu7 as ByteChannel } from './ByteChannel.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function attachWriterJob(_this__u8e3s4, writerJob) {
  var tmp = writerJob.p4n_1;
  var tmp0_safe_receiver = tmp instanceof ByteChannel() ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.e4n((cause) => {
      var tmp;
      if (!(cause == null)) {
        _this__u8e3s4.d4n(cause);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  attachWriterJob as attachWriterJob2dr3tee7atoa9,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
